"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const toast_1 = require("./toast");
const use_toast_1 = require("../../../../../hooks/use-toast");
const Toaster = () => {
    const { toasts } = (0, use_toast_1.useToast)();
    return ((0, jsx_runtime_1.jsxs)(toast_1.Toast.Provider, { duration: 8000, children: [toasts.map(({ id, title, description, action, ...props }) => ((0, jsx_runtime_1.jsxs)(toast_1.Toast, { ...props, children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid gap-1", children: [title && (0, jsx_runtime_1.jsx)(toast_1.Toast.Title, { children: title }), description && ((0, jsx_runtime_1.jsx)(toast_1.Toast.Description, { children: description }))] }), action, (0, jsx_runtime_1.jsx)(toast_1.Toast.Close, {})] }, id))), (0, jsx_runtime_1.jsx)(toast_1.Toast.Viewport, {})] }));
};
exports.Toaster = Toaster;
